module.exports = __webpack_public_path__ + "static/media/relogio1.0ac38102.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/relogio1.png
// module id = 56
// module chunks = 0